<script setup lang="ts">
  import { useTemplateRef } from 'vue';

  import { Button } from '@ui/components/button';
  import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from '@ui/components/dialog';
  import { ScrollArea } from '@ui/components/scroll-area';

  import DisputeForm from '@/components/disputes/DisputeForm.vue';

  interface Props {
    customerId?: string;
    invoiceId?: string;
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{
    (e: 'complete'): void;
    (e: 'close'): void;
  }>();

  const DisputeFormRef = useTemplateRef<InstanceType<typeof DisputeForm>>('disputeFormRef');
</script>

<template>
  <Dialog :open="true" @update:open="(value) => !value && emit('close')">
    <DialogContent
      class="w-[480px] max-w-[480px] text-xs gap-y-8"
      :disable-dismiss-on="['interact-outside']"
      :on-escape-key-down="() => emit('close')"
    >
      <DialogHeader>
        <DialogTitle> Create new dispute </DialogTitle>
      </DialogHeader>

      <ScrollArea class="h-[450px] [&>div]:outline-none">
        <DisputeForm
          ref="disputeFormRef"
          :initial-data="{
            invoice: invoiceId,
            partner: customerId,
          }"
          @complete="emit('complete')"
          @close="emit('close')"
        />
      </ScrollArea>

      <DialogFooter>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          :disabled="DisputeFormRef?.submitting"
          @click="emit('close')"
        >
          Close
        </Button>

        <Button
          type="submit"
          variant="primary"
          size="sm"
          :disabled="DisputeFormRef?.submitting"
          @click="DisputeFormRef?.submit"
        >
          Create
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<style scoped></style>
